module.exports = __webpack_public_path__ + "static/media/chats.35c730e3.svg";